export const ConversationSkeleton = () => (
  <div className="flex flex-col gap-2">
    {[1, 2, 3, 4, 5].map((num) => (
      <div
        key={num}
        className="flex items-center gap-4 py-1 px-4 rounded-xl cursor-pointer animate-pulse bg-tertiary"
      >
        <div className="w-12 h-12 rounded-full object-cover bg-white bg-opacity-10" />
        <div className="flex flex-col gap-2 flex-1">
          <div className="w-1/2 h-3 rounded-full bg-white bg-opacity-10" />
          <div className="w-1/4 h-3 rounded-full bg-white bg-opacity-10" />
        </div>
      </div>
    ))}
  </div>
);
